/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var dropGroup = '';
var keyPath = [];

var getDropGroup = function getDropGroup(_ref) {
  var ranges = _ref.ranges,
      dragBoxRegion = _ref.dragBoxRegion;
  var boxTop = dragBoxRegion.top;
  ranges.filter(function (row) {
    if (boxTop >= row.top && boxTop <= row.bottom) {
      dropGroup = row.keyPath.join('/');
      keyPath = row.keyPath;
    }
  });
  return {
    dropGroup: dropGroup,
    keyPath: keyPath
  };
};

var _default = getDropGroup;
exports.default = _default;